import { StorageKey } from "@app/constants";
import { ApiResponseDef, TokenDef } from "@app/types";
import { useCookies } from "react-cookie";

export const useToken = () => {
  const [cookies, setCookie, removeCookie] = useCookies([
    StorageKey.AUTH_ACCESS_TOKEN,
    StorageKey.LAST_UPDATED_AT,
  ]);

  const saveTokens = ({
    token,
    accountId = cookies.tokens?.accountId,
  }: ApiResponseDef) => {
    const cookieToken: TokenDef = {
      accessToken: token,
      accountId,
    };

    setCookie(StorageKey.AUTH_ACCESS_TOKEN, cookieToken, {
      path: "/",
    });
  };

  const getTokens = () => {
    const cookieToken: TokenDef | undefined =
      cookies[StorageKey.AUTH_ACCESS_TOKEN];

    return {
      accessToken: cookieToken?.accessToken,
      refreshToken: cookieToken?.refreshToken,
      expiresAt: cookieToken?.expiresAt,
    } as TokenDef;
  };

  const clearTokens = () => {
    try {
      removeCookie(StorageKey.AUTH_ACCESS_TOKEN, { path: "/" });

      const hostname = window.location.hostname;
      const cookieName = StorageKey.AUTH_ACCESS_TOKEN;
      const paths = ["/", window.location.pathname];
      const domains = [
        hostname,
        `.${hostname}`,
        ...(hostname.includes(".")
          ? [
              hostname.split(".").slice(-2).join("."),
              `.${hostname.split(".").slice(-2).join(".")}`,
            ]
          : []),
        "localhost",
      ];

      paths.forEach((path) => {
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path}`;
        domains.forEach((domain) => {
          document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};domain=${domain}`;
        });
      });

      if (hostname === "localhost" || hostname.includes("localhost")) {
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=localhost`;
      }
    } catch (error) {
      console.error("Error clearing tokens:", error);
    }
  };

  return {
    cookies,
    getTokens,
    saveTokens,
    clearTokens,
  };
};
